import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '../../lib/utils';

export default function BrandLogo({ className, showName = true, name, to = '/' }) {
  const content = (
    <>
      <div className="flex size-8 shrink-0 items-center justify-center rounded-full bg-primary-500 text-primary-900">
        <div className="grid size-3.5 grid-cols-2 gap-0.5">
          {[0, 1, 2, 3].map((i) => (
            <div key={i} className="size-1.5 rounded-[1px] bg-background-secondary" />
          ))}
        </div>
      </div>
      {showName && name ? (
        <span className="truncate text-base font-semibold text-text-primary">{name}</span>
      ) : null}
    </>
  );

  const classes = cn('flex items-center gap-2', className);

  if (to) {
    return (
      <Link to={to} className={classes} aria-label={name}>
        {content}
      </Link>
    );
  }

  return <div className={classes}>{content}</div>;
}
